import React, { Component, Fragment } from 'react'
import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'
import DashboardLayout from './../../components/Admin/DashboardLayout'
import PageHeading from './../../components/shared/PageHeading.component'
import Sidebar from './components/Sidebar/Sidebar.component'
import MarkdownViewer from './components/MarkdownViewer/MarkdownViewer.component'
import SearchBar from './components/SearchBar/SearchBar.component'
import Store from './store'

import './UserManuals.page.scss'

class UserManualsPage extends Component {
  componentDidMount() {
    Store.loadManuals()
  }

  render() {
    return (
      <Fragment>
        <DashboardLayout>
          <main id='UserManualsPage' className='mainSection pb-5'>
            <MDBContainer fluid className='mt-4'>
              <PageHeading
                label='Backoffice User Manuals'
                url={this.props?.match?.url}
                from={this.props?.location?.state?.from}
                goTo={url => this.props.history.push(url, { from: '/user-manuals' })}
              />
            </MDBContainer>
            <MDBContainer fluid>
              <MDBRow>
                <MDBCol size='12'>
                  <SearchBar />
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol size='12' md='3' className='mb-4'>
                  <Sidebar />
                </MDBCol>
                <MDBCol size='12' md='9' className='mb-4'>
                  <MarkdownViewer />
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default UserManualsPage
